import {Button, Layout, message, Space, Spin, Table} from "antd";
import React, {Component} from "react";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavBreadcrumb from "../../components/NavBreadcrumb";

import NavFooter from "../../components/NavFooter";
import AxiosUtil from "../../utils/AxiosUtil";

import {CarryOutOutlined, ReloadOutlined,CloudDownloadOutlined} from "@ant-design/icons";

const { Content } = Layout;

interface IProps {
}

export default class TaskPublish extends Component<IProps> {

    state = {
        showLoading:false,
        mainData: []
    }

    componentDidMount() {
        this.loadMainData(1);
    }

    render() {

        const crumb = [
            {name: '智能研报'},
            {name: '提交发布'},
        ];
        const columns = [
            {title: "日期", key: "reportDay", dataIndex: "reportDay", width: 100, align: "center" as "center"},
            {title: "状态", key: "param_name", dataIndex: "param_name", width: 60, align: "center" as "center"},
            {title: "研报数", key: "recordCount", dataIndex: "recordCount", width: 60, align: "center" as "center"},
            {title: "PDF数", key: "reportCount", dataIndex: "reportCount", width: 60, align: "center" as "center"},
            {title: "状态说明", key: "remark", dataIndex: "remark", width: 100},
            {title: "发布时间", key: "create_time", dataIndex: "create_time", width: 100, align: "center" as "center"},
            {title: "完成时间", key: "update_time", dataIndex: "update_time", width: 100, align: "center" as "center"},
            {
                title: "打包下载", key: "fileUrl", dataIndex: "fileUrl", width: 100, align: "center" as "center",
                render: (url: string) => (
                    <a href={url.replaceAll("%2F", "/")} key={1}><CloudDownloadOutlined/> CSV下载</a>
                )
            },
        ];

        return (
            <Layout>
                <NavHeader/>
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>

                            <Spin tip="Loading..." size="large" spinning={this.state.showLoading}>
                                <div id="toolBar" style={{marginBottom: 16}}>
                                    <Space size={32}>
                                        <Button key={1} type="primary"
                                                onClick={this.postTaskPublish}><CarryOutOutlined/>提交发布</Button>
                                        <Button type="link"
                                                onClick={(e) => this.loadMainData()}><ReloadOutlined/> 刷新</Button>
                                    </Space>
                                </div>
                                <Table key="pubList"
                                       rowKey={"update_time"}
                                       size="small"
                                       columns={columns}
                                       dataSource={this.state.mainData}
                                       bordered
                                />
                            </Spin>

                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>
        );
    }

    postTaskPublish = () => {

        this.setState({showLoading: true});

        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                message.success({content: "已提交发布，请刷新查看数据", className: 'message_success'});
                this.loadMainData(1);
            }
            this.setState({showLoading: false});
        }
        AxiosUtil.AxiosRequest("/api/yb/ys_new", {}, callback);
    };

    loadMainData = (pageIndex?: number) => {

        this.setState({showLoading: true});

        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({mainData: dat.list})
            }
            this.setState({showLoading: false});
        }
        const queryParam = {
            pageIndex: pageIndex || 1,
            pageSize: 20,
            type: 1,
            // beginTime: moment().add(-30,"day").format("YYYY-MM-DD"),
            // endTime: moment().format("YYYY-MM-DD"),
        };
        AxiosUtil.AxiosRequest("/api/log/getHwyLog", queryParam, callback);
    };
}